import PropTypes from 'prop-types';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';

import './Stars.css';

const Stars = ({ rating, size = 14, extraClass = '', color = '#f7c852' }) => {
    const hasHalfStar = rating % 1 > 0;
    const fullStars = Math.floor(rating);

    return (
        <div className={`ab-desktop-widget-stars ${extraClass}`}>
            {[...Array(fullStars).keys()].map((_, index) => {
                return <FaStar key={index} size={size} color={color} />;
            })}
            {hasHalfStar && <FaStarHalfAlt size={size} color={color} />}
        </div>
    );
};

Stars.propTypes = {
    rating: PropTypes.number.isRequired,
    size: PropTypes.number,
    extraClass: PropTypes.string,
    color: PropTypes.string,
};

export default Stars;
